import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { compose } from 'recompose'
import { parse } from 'qs'

import Alert from 'components/common/bs-alert'


const AuthAlerts = ({ error, location: { search } }) => {
  const { success } = parse(search.substr(1));
  if (!error && !success) {
    return null;
  }

  let alertType;

  if (success) {
    alertType = 'success';
  } else if (error) {
    alertType = 'error';
  }

  return (
    <Alert type={ alertType }>
      { alertType === 'success' && success }
      { alertType === 'error' && error }
    </Alert>
  );
}

AuthAlerts.propTypes = {
  error: PropTypes.string,
  success: PropTypes.string,
}

export default compose(
  connect(({ auth: { error, success } }) => ({ error, success })),
  withRouter,
)(AuthAlerts)



// WEBPACK FOOTER //
// ./src/components/auth/auth-alerts.js